module.exports = __webpack_public_path__ + "img/clock-history.f742dff3.svg";